const KEY = "wc-saved-sims";

function readAll() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeAll(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {}
}

export function listSims() {
  return readAll().sort((a, b) => b.updated_at - a.updated_at);
}

export function saveSim(name, state) {
  const list = readAll();
  const existing = list.findIndex((s) => s.name.toLowerCase() === name.toLowerCase());
  const now = Date.now();
  const entry = {
    id: existing >= 0 ? list[existing].id : `sim_${now}`,
    name: name.trim(),
    startYear: state.startYear,
    startMonth: state.startMonth,
    inputs: state.inputs,
    created_at: existing >= 0 ? list[existing].created_at : now,
    updated_at: now,
  };
  if (existing >= 0) list[existing] = entry;
  else list.push(entry);
  writeAll(list);
  return entry;
}

export function loadSim(id) {
  return readAll().find((s) => s.id === id) || null;
}

export function deleteSim(id) {
  writeAll(readAll().filter((s) => s.id !== id));
}
